var SET_IS_POST_LOADING = 'SET_IS_POST_LOADING';
var FETCH_POSTS = 'FETCH_POSTS';
var SELECT_POST = 'SELECT_POST';
var SET_FILTER = 'SET_FILTER';
var FETCH_POST = 'FETCH_POST';
var SEARCH_SUCCESS = 'SEARCH_SUCCESS';
var SEARCH_FAILED = 'SEARCH_FAILED';
var GET_ALL_TAGS = 'GET_ALL_TAGS';
var NEW_POST = 'NEW_POST';
var IMAGE_UPLOAD = 'IMAGE_UPLOAD';

var API_URL = process.env.REACT_APP_API_URL.includes('localhost') ? '' : process.env.REACT_APP_API_URL;
var getAllPostIds = function getAllPostIds() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/getAllPostIds")).then(function (res) {
        return res.json();
      }).then(function (posts) {
        if (!posts.ok) {
          reject(posts);
        } else {
          resolve(posts);
        }
      });
    });
  };
};
var setPostLoading = function setPostLoading(condition) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: SET_IS_POST_LOADING,
        payload: condition
      });
    });
  };
};
var getPostById = function getPostById(id) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      console.log('getPostById'); // Show spinner

      dispatch({
        type: SET_IS_POST_LOADING,
        payload: true
      });
      fetch("".concat(API_URL, "/api/v1/blog/get/").concat(id), {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: FETCH_POST,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: FETCH_POST,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var fetchPosts = function fetchPosts(pageSize, pageNo, queryObject) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      // Show spinner
      dispatch({
        type: SET_IS_POST_LOADING,
        payload: true
      });
      var query = "";

      if (Object.keys(queryObject).length > 0) {
        for (var key in queryObject) {
          if (Object.hasOwnProperty.call(queryObject, key)) {
            var element = queryObject[key];
            query = "".concat(query, "&").concat(key, "=").concat(element);
          }
        }
      }

      fetch("".concat(API_URL, "/api/v1/blog/?page_size=").concat(pageSize, "&page=").concat(pageNo).concat(query)).then(function (res) {
        return res.json();
      }).then(function (posts) {
        dispatch({
          type: SET_IS_POST_LOADING,
          payload: false
        });

        if (!posts.ok) {
          dispatch({
            type: FETCH_POSTS,
            payload: posts
          });
          reject(posts);
        } else {
          dispatch({
            type: FETCH_POSTS,
            payload: posts
          });
          resolve(posts);
        }
      });
    });
  };
};
var selectPost = function selectPost(postData) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: SELECT_POST,
        payload: postData
      });
      resolve(postData);
    });
  };
};
var setFilter = function setFilter(filter) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: SET_FILTER,
        payload: filter
      });
      resolve(filter);
    });
  };
};
var createSearch = function createSearch(page, page_size, keyword) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/search?").concat(page_size && page_size !== '' ? "page_size=".concat(page_size) : '').concat(page && page !== '' ? "&page=".concat(page) : '', "&title=").concat(keyword), {
        method: 'GET',
        headers: {
          "content-type": "application/json"
        },
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        if (!post.ok) {
          dispatch({
            type: SEARCH_FAILED,
            payload: post
          });
          reject(post);
        } else {
          dispatch({
            type: SEARCH_SUCCESS,
            payload: post
          });
          resolve(post);
        }
      });
    });
  };
};
var getAllTags = function getAllTags() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/getFilterOptions")).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: GET_ALL_TAGS,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var uploadImage = function uploadImage(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/image-upload"), {
        method: 'POST',
        credentials: 'include',
        body: data
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: IMAGE_UPLOAD,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var createPost = function createPost(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/create"), {
        method: 'POST',
        credentials: 'include',
        body: data
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: NEW_POST,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var updatePost = function updatePost(id, data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/update/").concat(id), {
        method: 'POST',
        credentials: 'include',
        body: data
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: NEW_POST,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};
var deletePost = function deletePost(id, data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      fetch("".concat(API_URL, "/api/v1/blog/delete/").concat(id), {
        method: 'DELETE',
        headers: {
          "content-type": "application/json"
        },
        credentials: 'include',
        body: JSON.stringify(data)
      }).then(function (res) {
        return res.json();
      }).then(function (post) {
        dispatch({
          type: FETCH_POSTS,
          payload: post
        });

        if (!post.ok) {
          reject(post);
        } else {
          resolve(post);
        }
      });
    });
  };
};

export { FETCH_POSTS as F, GET_ALL_TAGS as G, IMAGE_UPLOAD as I, NEW_POST as N, SEARCH_FAILED as S, createSearch as a, setPostLoading as b, createPost as c, selectPost as d, getAllTags as e, fetchPosts as f, getPostById as g, uploadImage as h, getAllPostIds as i, SEARCH_SUCCESS as j, FETCH_POST as k, SET_FILTER as l, SET_IS_POST_LOADING as m, SELECT_POST as n, deletePost as o, setFilter as s, updatePost as u };
